import React from "react";
import SglContext from "../SglContext";
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios'
import horse_logo from '../images/horse-logo.png'
import './alllivestreams.css'

// const sgl_webservice_livestream_detail = Sgl.nestApiUrl + '/livestream/';
// const user_info_url = Sgl.nestApiUrl + '/users/getUser';

var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const credit_text = process.env.REACT_APP_CREDIT_TEXT;
const credit_url = process.env.REACT_APP_CREDIT_URL;
const credit_company = process.env.REACT_APP_CREDIT_COMPANY
const copyright_text = process.env.REACT_APP_COPYRIGHT_TEXT

var moment = require('moment');
class LivestreamDetail extends React.Component {

    get sgl_webservice_livestream_detail() {
     return this.context.nestApiUrl + '/livestream/';
    }

    get user_info_url() {
     return this.context.nestApiUrl + '/users/getUser';
    }

    state = {
        livestream_data: {},
        livestream_source: '',
        userData: {},
        loading: true
    }
    sgl_special_events_id = this.getQueryVariable('se_id');

    constructor() {
        super();
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        this.getLivestreamDetails();

        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
        eventer(messageEvent, function (e) {
            var iFrameID = document.getElementById('live_stream_iframe');
            if (iFrameID) {
                var key = e.message ? "message" : "data";
                var data = e[key].split(":");
                iFrameID.height = data[1] + "px";
                iFrameID.style.height = data[1] + "px";
            }
        }, false);
    }

    componentDidUpdate(prevProps, prevState) {
        let id = this.sgl_special_events_id
        this.sgl_special_events_id = this.getQueryVariable('se_id');
        if (id !== this.sgl_special_events_id) {
            this.getLivestreamDetails();
        }
    }

    getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] === variable) { return pair[1]; }
        }
        return (false);
    }

    getLivestreamDetails() {

        axios.get(this.sgl_webservice_livestream_detail + this.sgl_special_events_id, {
            params: {
                se_id: this.sgl_special_events_id,
                customer_id: this.context.company_id
            },
        })
            .then((res) => {
                console.log("livestream data", res.data.livestream_data)
                this.context.reportToGA('/sgl-wp-plugin/' + this.context.company_urlpath + '/specialevents/detail/' + this.sgl_special_events_id);
                this.context.reportToFB('/sgl-wp-plugin/' + this.context.company_urlpath + '/specialevents/detail/' + this.sgl_special_events_id);
                this.setState({
                    livestream_data: res.data.livestream_data,
                    livestream_source: res.data.livestream_source,
                    loading: false
                })
                this.getSpecialEventsData(1);
            });
    }
    getSpecialEventsData(page) {
        axios.get(this.sgl_webservice_livestream_detail + "specialEvents", {
            params: {
                page: page,
                customer_id: this.context.company_id
            },
        })
            .then((res) => {
                console.log("special events", res.data.special_events)
                this.setState({
                    special_events: res.data.special_events,
                    total_rows: res.data.total_rows,
                    loading: false
                })
            });
    }

    Label = (name) => {
        if (!name) return '';
        if (name.length > 55) {
            let result = name.substring(0, 55);
            name = result + "..."
        }
        return name;
    }

    render() {
        const loading = this.state.loading;

        if (loading) {
            return null;
        }

        return (
            <div style={{ 'minHeight': '600px' }}>
                <section className="search-area">
                <h1>{this.state.livestream_data.title}</h1>
                <div className="credit-text">{credit_text} <a href={credit_url}>{credit_company}</a></div>
                <iframe id='livestream_iframe' allowFullScreen="allowfullscreen" webkitallowfullscreen="true" mozallowfullscreen="true" src={this.context.sglApiUrl + this.state.livestream_source}></iframe>
                {/* <div className="view-count">
                    <span className="live-view">Live Views: {this.state.livestream_data.live_views}, </span>
                    <span className="archive-view">Archive Views: {this.state.livestream_data.archive_views}, </span>
                    <span className="total-view">Total Views: {this.state.livestream_data.live_views + this.state.livestream_data.archive_views}</span>
                </div> */}
                <h2 className="sgl-h2">Latest Live Streams</h2>
                <div
                    id="livestream_listing"
                    className="grid"
                >
                    <div id="sgl-livestream-card-container" className="flex-livestream-container">

                        {this.state.total_rows > 0 ? (
                            this.state.special_events.map((special_event, index) => {
                                let event_date = special_event.hasOwnProperty('event_date') ? new Date(special_event.event_date) : null;
                                return (

                                    <div key={index} className="sgl-archive-event">
                                        <Link className="sgl-link" to={'/livestream/detail?se_id=' + special_event.sgl_id}>
                                            <img src={special_event.placeholder_image} alt="" srcSet="" />
                                            <div className="sgl-description">
                                                <div className="sgl-text">{this.Label(special_event.title)}</div>
                                            </div>
                                            {special_event.event_date && moment(special_event.event_date).isValid() && (
                                                <div className="sgl-badge">
                                                    <div className="sgl-badge-inner">
                                                        <span className="sgl-day">{moment(event_date).format("D")}</span>
                                                        <span className="sgl-month">{moment(event_date).format("MMM")}</span>
                                                        <span className="sgl-year">{moment(event_date).format("YYYY")}</span>
                                                    </div>
                                                </div>
                                            )}
                                        </Link>
                                    </div>

                                );
                            })
                        ) : (
                            <div className="livestream_container ">
                                <div className="livestream-content">
                                    <div className="thumb-image">
                                        <img src={horse_logo} />
                                        <span className="float-left">No Live Streams Found</span>
                                    </div>
                                </div>
                            </div>
                        )}
                        <br />
                    </div>
                </div>
                <div className="copyright-text">{copyright_text}</div>
                </section>
            </div >
        )
    }
}


LivestreamDetail.navigate = useNavigate;
LivestreamDetail.contextType = SglContext;
export default LivestreamDetail;
